module.exports = __webpack_public_path__ + "img/10kjjr.ff31de53.svg";